import React from "react";
import { Helmet } from "react-helmet-async";
import type { Lang } from "@/content/translations";

/**
 * Canonical hostname for SEO. Hardcoded so canonical links emitted on
 * any deploy alias (the legacy `nabil-tawfik-site.pages.dev` fallback
 * and any preview deploys) all point search engines back at the real
 * production URL — preventing duplicate-content indexing of
 * `pages.dev` traffic against the canonical site.
 */
const CANONICAL_ORIGIN = "https://nabiltawfik.com";

export const Seo: React.FC<{
  title: string;
  description: string;
  lang: Lang;
  path?: string;
  ogImage?: string;
}> = ({ title, description, lang, path, ogImage }) => {
  const canonical = path
    ? `${CANONICAL_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`
    : undefined;
  return (
    <Helmet>
      <html lang={lang} dir={lang === "ar" ? "rtl" : "ltr"} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}
      {canonical && <meta property="og:url" content={canonical} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
    </Helmet>
  );
};
